import { render } from "./RequestDetailsView.vue?vue&type=template&id=3ec7d83b&scoped=true"
import script from "./RequestDetailsView.vue?vue&type=script&lang=js"
export * from "./RequestDetailsView.vue?vue&type=script&lang=js"

import "./RequestDetailsView.vue?vue&type=style&index=0&id=3ec7d83b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec7d83b"]])

export default __exports__